// KitchenDashboard.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './KitchenDashboard.css';
import { useKitchenData } from './Context/KitchenDataContext';
import KitchenSidebar from './KitchenSidebar';

const KitchenDashboard = () => {
  const navigate = useNavigate();
  const { dietPlans, menuItems, getMealsForDay } = useKitchenData();
  
  const today = new Date();
  const todayStr = today.toISOString().split('T')[0];
  const todayDisplay = today.toLocaleDateString('en-US', { 
    weekday: 'long', 
    month: 'long', 
    day: 'numeric' 
  });
  
  const todayMeals = getMealsForDay(todayStr);
  const totalMealsScheduled = todayMeals.reduce((sum, meal) => sum + meal.quantity, 0);

  // Generate quick summary data based on actual schedule
  const quickSummary = [
    { time: '08:00 AM', meals: todayMeals.filter(m => m.time === '08:00').length, items: todayMeals.filter(m => m.time === '08:00').reduce((sum, m) => sum + m.quantity, 0) },
    { time: '10:30 AM', meals: todayMeals.filter(m => m.time === '10:30').length, items: todayMeals.filter(m => m.time === '10:30').reduce((sum, m) => sum + m.quantity, 0) },
    { time: '01:00 PM', meals: todayMeals.filter(m => m.time === '13:00').length, items: todayMeals.filter(m => m.time === '13:00').reduce((sum, m) => sum + m.quantity, 0) },
    { time: '04:00 PM', meals: todayMeals.filter(m => m.time === '16:00').length, items: todayMeals.filter(m => m.time === '16:00').reduce((sum, m) => sum + m.quantity, 0) },
    { time: '08:00 PM', meals: todayMeals.filter(m => m.time === '20:00').length, items: todayMeals.filter(m => m.time === '20:00').reduce((sum, m) => sum + m.quantity, 0) },
  ];

  // Food codes reference from available menu items
  const foodCodesReference = Object.values(menuItems).slice(0, 3).map(item => ({
    code: item.code,
    title: item.name,
    desc: item.description,
    meta: `${item.ingredients.length} ingredients • ${item.nutrition.calories} cal`
  }));

  return (
    <div className="kitchen-layout">
      <KitchenSidebar />
      <div className="kitchen-root col-10">
        <div className="kitchen-header">
          <div>
            <h1 className="kh-title">felixaTouch Wellness Kitchen Dashboard</h1>
            <div className="kh-date">{todayDisplay}</div>
          </div>
        </div>

        <div className="kh-top-cards">
          <div className="kh-card" onClick={() => navigate('/kitchen/patient-diets')}>
            <div className="kh-card-title">Patient Diets</div>
            <div className="kh-card-metric">{dietPlans.length}</div>
            <div className="kh-card-sub">Active diet plans</div>
            <button className="kh-link">View meal requirements →</button>
          </div>
          <div className="kh-card" onClick={() => navigate('/kitchen/daily-schedule')}>
            <div className="kh-card-title">Daily Schedule</div>
            <div className="kh-card-metric">{totalMealsScheduled}</div>
            <div className="kh-card-sub">Scheduled meals for today</div>
            <button className="kh-link">View daily schedule →</button>
          </div>
        </div>

        <div className="kh-main">
          <div className="kh-left">
            <div className="kh-panel">
              <div className="kh-panel-title">Quick Summary</div>
              <table className="kh-table">
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Meals Scheduled</th>
                    <th>Unique Food Items</th>
                  </tr>
                </thead>
                <tbody>
                  {quickSummary.map(row => (
                    <tr key={row.time}>
                      <td>{row.time}</td>
                      <td>{row.items}</td>
                      <td>{row.meals}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="kh-right">
            <div className="kh-panel">
              <div className="kh-panel-title">Food Code Reference</div>
              <div className="kh-list">
                {foodCodesReference.map(item => (
                  <div key={item.code} className="kh-list-item">
                    <div>
                      <div className="kh-list-title">{item.title}</div>
                      <div className="kh-list-desc">{item.desc}</div>
                      <div className="kh-list-meta">{item.meta}</div>
                    </div>
                    <div className="kh-chip">{item.code}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KitchenDashboard;